import { CreateTemplateGroupRequest, CreateTemplateRequest, CreateVariableRequest } from '@/types/api/request/createTemplateTypes';
import BaseService from './baseService';
import ResponseErrorCheckInterceptor from './interceptors/responseErrorCheckInterceptor';
import RequestAuthorizationInterceptor from './interceptors/requestAuthorizationInterceptor';
import ResponseSuccessCheckInterceptor from '@/api/interceptors/responseSuccessCheckInterceptor';
import { convertVariable, convertCreateVariableRequest } from './templateTypeConverter';
import { FetchVariablesParams } from '@/types/api/params/fetchVariablesParams';

class TemplatesService extends BaseService {
	constructor() {
		const baseAPIUrl = process.env.VUE_APP_BASE_API_URL;
		super(baseAPIUrl);
		this.http.interceptors.request.use(RequestAuthorizationInterceptor);
		this.http.interceptors.response.use(ResponseSuccessCheckInterceptor, ResponseErrorCheckInterceptor);
	}

	async getTemplates() {
		const response = await super.get('/service/template');

		return { ...response, data: response.data };
	}

	async deleteTemplate(name: string) {
		return super.post('/service/template_delete', { name: name });
	}

	async getTemplateGroups() {
		return this.get('/service/template_group');
	}

	async getVariables(params?: FetchVariablesParams) {
		const response = await super.post('/data-structure/sys_lx_notification_variable/search', {
			unPaged: true,
		});

		return { ...response, data: { ...response.data, data: response.data.data.entities.map((variable: any) => convertVariable(variable)) } };
	}

	async createTemplate(data: CreateTemplateRequest) {
		return super.post('/service/create_template', data);
	}

	async updateTemplate(template: CreateTemplateRequest) {
		return super.post('/service/template-update', template);
	}

	async createGroup(data: CreateTemplateGroupRequest) {
		return this.post('/data-structure/sys_lx_notification_template_group/save', data);
	}

	async updateGroup(data: CreateTemplateGroupRequest) {
		return this.post('data-structure/sys_lx_notification_template_group/save', data);
	}

	async deleteGroup(id: number) {
		return this.post('data-structure/sys_lx_notification_template_group/save', { id: id, _delete: true });
	}

	async createVariable(data: CreateVariableRequest) {
		return super.post('/data-structure/sys_lx_notification_variable/save', convertCreateVariableRequest(data));
	}

	async deleteVariable(id: number) {
		return super.post('/data-structure/sys_lx_notification_variable/save', { id: id, _delete: true });
	}
}

export default new TemplatesService();
